<!-- Trigger the modal with a button -->
<!-- <button type="button" class="btn btn-info btn-lg" data-toggle="modal" data-target="#myModal">Open Modal</button> -->

<!-- Modal -->
<div id="myModal" class="modal fade rating-modal" role="dialog">
  <div class="modal-dialog modal-lg rating-modal-dialog">
    <div class="modal-header rating-header">
      <button type="button" class="close" data-dismiss="modal">&times;</button>
    </div>
    <!-- Modal content-->
    <div class="modal-content rating-content">
      <div class="modal-body">
        <div class="section-title">
          <span>Rating</span>
        </div>
        <div class="section-heading">
          <span>How would you rate this asset?</span>
        </div>
        <div class="star-rating">
          <app-star-rating [allowClick]="true" [rating]="previousRatings" (ratingClick)="getRatingDetails($event)"></app-star-rating>
        </div>
        <!-- <div class="rating-description section-heading">
          <span>{{ratingDesc}}</span>
        </div> -->

        <div class="section-title">
          <span>Comment</span>
        </div>
        <!-- <div class="section-heading">
          <span>Please share your thoughts about this asset.</span>
        </div> -->
        <div class="comment-textarea">
            <!-- <span class="section-title">Comment</span> -->
            <span *ngIf="remarks_textbox" class="wordcount wordcounter">{{checkLength(remarks_textbox)}}/200</span>
            <div class="full-width">
              <textarea class="reqTextareaedit" placeholder="Add Comments here" rows="7" cols="40" name="remarks_txtbox"
                [(ngModel)]="remarks_textbox" maxlength="200"></textarea>
            </div>
        </div>

      </div>
      <div class="modal-footer d-flex justify-content-center">
        <button type="button" (click)="submitReviews(remarks_textbox)" 
        [disabled]="disableSubmit?true : null"
        [title] = "disableSubmit? 'Please update comments and ratings to submit' : '' "
        class="btn btn-primary submit-btn">SUBMIT</button>
      </div>
    </div>

  </div>
</div>

<basic-dialog *ngIf="ReviewssuccessPopup" [visible]="ReviewssuccessPopup" [modalId]="ReviewsSuccessModal"
      [modalStyles]="{ 'min-width': '455px', width: '455px', right: '-10px' }" [dialogStyles]="{ height: '100%' }">
      <div class="modal-body successTick">
         <img [src]="successTickImgScr" alt="greentickimg" />
         <h4>Thanks for your feedback!</h4>
      </div>
      <br>
      <div class="modal-footer">
         <button type="button" class="btn btn-hover btn-border"
            (click)="modalOkClicked('ReviewssuccessPopup')">OK</button>
      </div>
</basic-dialog>

<basic-dialog *ngIf="ReviewsErrorPopup" [visible]="ReviewsErrorPopup" [modalId]="ReviewsErrorModal"
[modalStyles]="{ 'min-width': '655px', width: '655px', right: '-10px' }" [dialogStyles]="{ height: '100%' }">
<div class="modal-body successTick m-t">
   <img [src]="failedExcalamImgSrc" alt="exclamationimg" />
   <h4 style="padding-top:1%;">An Error Occured. Please try again later.
   </h4>
</div>
<br>
<div class="modal-footer">
   <button type="button" class="btn btn-hover btn-border"
      (click)="modalOkClicked('ReviewsErrorPopup')">OK</button>
</div>
</basic-dialog>